export const MunicipalitiesData = [
  { id: '1', value: "Δήμος Αποκορώνου", item: "Αποκορώνου" },
  { id: '2', value: "Δήμος Γαύδου",     item: "Γαύδου" },
  { id: '3', value: "Δήμος Καντάνου - Σελίνου", item: "Καντάνου - Σελίνου" },
  { id: '4', value: "Δήμος Κισσάμου",   item: "Κισσάμου" },
  { id: '5', value: "Δήμος Πλατανιά",   item: "Πλατανιά" },
  { id: '6', value: "Δήμος Σφακίων",    item: "Σφακίων" },
  { id: '7', value: "Δήμος Χανίων",     item: "Χανίων" }
]